// The reachability feed (C1 input `api_result`): every API request apiFetch
// makes reports whether the server answered, with the path epoch it STARTED
// under. Plain lets and functions, no imports and no browser global, so
// apiFetch (in the prerender graph) can import it.

let epoch = 0
let sink: ((success: boolean, startEpoch: number) => void) | null = null

/** The path epoch now: capture it when a request starts. */
export function beginApiRequest(): number {
  return epoch
}

/** The connectivity host keeps this in step with its machine. */
export function setFeedEpoch(value: number): void {
  epoch = value
}

export function setFeedSink(fn: ((success: boolean, startEpoch: number) => void) | null): void {
  sink = fn
}

/** Spec 0.6, C1 column: an HTTP answer below 500 (a 401 included) is a success. */
export function reportApiStatus(status: number, startEpoch: number): void {
  sink?.(!(status >= 500 && status <= 599), startEpoch)
}

/** The request threw (no answer): a failure. A caller's own abort is not reported. */
export function reportApiFailure(startEpoch: number): void {
  sink?.(false, startEpoch)
}

/** Test seam. */
export function __resetConnectivityFeedForTests(): void {
  epoch = 0
  sink = null
}
